import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ConfigProvider } from "antd";
import type { Locale } from "antd/es/locale";
import enUS from "antd/locale/en_US";
import zhCN from "antd/locale/zh_CN";
import Routes from "./routes";
import { setCountry } from "./app/reducers/countryReducer";
import PageLayout from "./component/layout";
import { apiLog, getArea } from "./utils/api/common";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "./app/store";
import { asyncPublicCurrency, asyncUserInfo } from "@/app/reducers/headerSlice";
import { asyncInit } from "./app/reducers/cartReducer";
import { asyncNoticeInit } from "./app/reducers/noticeReducer";
import { asyncCompanyInit } from "./app/reducers/companyReducer";
import { asyncInitCommonMenus } from "./app/reducers/menuReducer";
import updateLocale from "dayjs/plugin/updateLocale";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
dayjs.extend(updateLocale);
interface Config {
  [k: string]: Locale;
}
function App() {
  const token = window.localStorage.getItem("token");
  const config: Config = { zh: zhCN, en: enUS };
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const { value } = useSelector((state: RootState) => state.lang);
  useEffect(() => {
    const getCountry = async () => {
      const { data: { data, code }, } = await getArea({ pid: 0 });
      if (+code === 0) {
        dispatch(setCountry((data as { list: object[] }).list));
      }
    };
    getCountry();
    dispatch(asyncPublicCurrency());
    if (token) {
      dispatch(asyncInit());
      dispatch(asyncNoticeInit());
      dispatch(asyncCompanyInit());
      dispatch(asyncInitCommonMenus());
      // 获取用户最新信息，并存储
      dispatch(asyncUserInfo());
    }
  }, [dispatch, token, value]);

  useEffect(() => {
    window.scrollTo(0, 0);
    apiLog({
      path: location.pathname,
      path_info: "",
      params: location.search,
      source: 3,
      uid: window.localStorage.getItem("user_id") || JSON.parse(window.localStorage.getItem("user_info") || "{}").user_id,
    });
  }, [location.search, location.pathname, ]);

  return (
    <ConfigProvider locale={config[value]} theme={{ token: { colorPrimary: "#D60505", controlHeight: 40 } }}>
      <PageLayout>
        <Routes />
      </PageLayout>
    </ConfigProvider>
  );
}

export default App;
